import { useLoading } from "shared/contexts/Loading";

import CoursesContent from "modules/enrollment/CoursesContent";
import CourseHub from "modules/enrollment/CourseHub";
import BatchesContent from "modules/enrollment/BatchesContent";
import StudentsContent from "modules/studenthub/StudentsContent";
import StudentRosterContent from "modules/enrollment/StudentRosterContent";
import EvaluationsPageContent from "modules/evaluation/EvaluationsContent";
import CreateUpdateBatchEnrollmentForm from "modules/enrollment/forms/CreateUpdateBatchEnrollmentForm";
import CreateUpdateBatchForm from "modules/enrollment/forms/CreateUpdateBatchForm";
import CreateUpdateCourseForm from "modules/enrollment/forms/CreateUpdateCourseForm";
import CreateUpdateStudentForm from "modules/studenthub/forms/CreateUpdateStudentForm";
import GlobalLoader from "./GlobalLoader";
import SubscriptionPlans from "./SubscriptionPlans";
import CreateUpdateEvaluationForm from "modules/evaluation/forms/CreateUpdateEvaluationForm";
import BatchEvaluationsContent from "modules/evaluation/BatchEvaluationsContent";
import CreateUpdateBatchEvaluationForm from "modules/evaluation/forms/CreateUpdateBatchEvaluationForm";
import AssignEvaluationToBatchForm from "modules/evaluation/forms/AssignEvaluationToBatchForm";
import BatchAssignmentsContent from "modules/evaluation/BatchAssignmentsContent";
import EvaluationAssignmentsContent from "modules/evaluation/EvaluationAssignmentsContent";
import AccountSettingsPage from "./AccountSettingsPage";
import AccountSettingsContent from "./AccountSettingsPage";
import ResourcesContent from "modules/resources/ResourcesContent";
import StudentsApp from "modules/studenthub/StudentsApp";
import CreateUpdateRequestEnrollmentForm from "modules/enrollment/forms/CreateUpdateRequestEnrollmentForm";
import AssignmentsContent from "modules/evaluation/AssignmentsContent";
import AnalyticsDashboard from "modules/dashboard/AnalyticsDashboard";
import App from "modules/resources/concepts/ConceptDetailsContent";
import ConceptsContent from "modules/resources/concepts/ConceptsContent";
import ConceptDetailsContent from "modules/resources/concepts/ConceptDetailsContent";
import MasterQuizApp from "modules/assessment/MasterQuizApp";
import StudentQuizApp from "modules/assessment/StudentQuizApp";

// The main layout wrapper that renders the header and current page content.
const Layout = ({
  HeaderComponent,
  isDropdownOpen,
  toggleDropdown,
  toggleTheme,
  isDarkMode,
  currentPage,
  navigateTo,
  selectedCourseTitle,
  selectedCourseId,
  selectedBatchId,
  useMockData,
  toggleMockMode,
  userName,
  userRole,
  profilePictureUrl,
  setLocale,
  displayToast,
  courseId,
  batchId,
  studentId,
  requestedCourseId,
  evaluationId,
  enrollmentId,
  conceptCode,
  quizMode
}) => {
  const { isLoading } = useLoading();
  return (
    <>
      <HeaderComponent
        isDropdownOpen={isDropdownOpen}
        toggleDropdown={toggleDropdown}
        toggleTheme={toggleTheme}
        isDarkMode={isDarkMode}
        currentPage={currentPage}
        navigateTo={navigateTo}
        toggleMockMode={toggleMockMode}
        useMockData={useMockData}
        userName={userName}
        userRole={userRole}
        profilePictureUrl={profilePictureUrl}
        setLocale={setLocale}
      />
      <div className="relative flex-1 bg-green-50 dark:bg-gray-900 transition-colors duration-500 min-h-screen ">
        {currentPage === "courses" && (
          <CoursesContent
            navigateTo={navigateTo}
            useMockData={useMockData}
            displayToast={displayToast}
          />
        )}
        {currentPage === "findCourses" && (
          <CoursesContent
            navigateTo={navigateTo}
            studentId={studentId}
            useMockData={useMockData}
            displayToast={displayToast}
            enroll={"true"}
          />
        )}
        {currentPage === "createRequestEnrollment" && (
          <CreateUpdateRequestEnrollmentForm
            navigateTo={navigateTo}
            studentId={studentId}
            courseId={requestedCourseId}
            enrollmentId={enrollmentId}
            useMockData={useMockData}
            displayToast={displayToast}
          />
        )}
        {currentPage === "createBatchEnrollment" && (
          <CreateUpdateBatchEnrollmentForm
            navigateTo={navigateTo}
            studentId={studentId}
            courseId={requestedCourseId}
            enrollmentId={enrollmentId}
            useMockData={useMockData}
            displayToast={displayToast}
          />
        )}
        {currentPage === "courseHub" && (
          <CourseHub
            navigateTo={navigateTo}
            selectedCourseTitle={selectedCourseTitle}
            selectedCourseId={selectedCourseId}
            useMockData={useMockData}
            displayToast={displayToast}
          />
        )}
        {currentPage === "myBatches" && (
          <BatchesContent
            navigateTo={navigateTo}
            selectedCourseTitle={selectedCourseTitle}
            selectedCourseId={selectedCourseId}
            useMockData={useMockData}
            displayToast={displayToast}
          />
        )}
        {currentPage === "students" && (
          <StudentsContent
            navigateTo={navigateTo}
            useMockData={useMockData}
            displayToast={displayToast}
          />
        )}
        {currentPage === "studentRoster" && (
          <StudentRosterContent
            navigateTo={navigateTo}
            selectedBatchId={batchId}
            selectedCourseId={selectedCourseId}
            selectedCourseTitle={selectedCourseTitle}
            useMockData={useMockData}
            displayToast={displayToast}
          />
        )}
        {currentPage === "subscriptionPlans" && (
          <SubscriptionPlans navigateTo={navigateTo} />
        )}{" "}
        {/* NEW PAGE RENDERING */}
        {currentPage === "evaluations" && (
          <EvaluationsPageContent
            navigateTo={navigateTo}
            useMockData={useMockData}
            displayToast={displayToast}
          />
        )}
        {currentPage === "createCourse" && (
          <CreateUpdateCourseForm
            navigateTo={navigateTo}
            selectedCourseId={selectedCourseId}
            selectedCourseTitle={selectedCourseTitle}
            useMockData={useMockData}
            displayToast={displayToast}
          />
        )}
        {currentPage === "updateCourse" && (
          <CreateUpdateCourseForm
            navigateTo={navigateTo}
            courseId={courseId}
            selectedCourseTitle={selectedCourseTitle}
            useMockData={useMockData}
            displayToast={displayToast}
          />
        )}
        {currentPage === "createBatch" && (
          <CreateUpdateBatchForm
            navigateTo={navigateTo}
            selectedCourseId={selectedCourseId}
            selectedCourseTitle={selectedCourseTitle}
            useMockData={useMockData}
            displayToast={displayToast}
          />
        )}
        {currentPage === "updateBatch" && (
          <CreateUpdateBatchForm
            navigateTo={navigateTo}
            batchId={batchId}
            selectedCourseId={selectedCourseId}
            selectedCourseTitle={selectedCourseTitle}
            useMockData={useMockData}
            displayToast={displayToast}
          />
        )}
        {currentPage === "createStudent" && (
          <CreateUpdateStudentForm
            navigateTo={navigateTo}
            useMockData={useMockData}
            displayToast={displayToast}
          />
        )}
        {currentPage === "updateStudent" && (
          <CreateUpdateStudentForm
            navigateTo={navigateTo}
            studentId={studentId}
            useMockData={useMockData}
            displayToast={displayToast}
          />
        )}
        {currentPage === "createEvaluation" && (
          <CreateUpdateEvaluationForm
            navigateTo={navigateTo}
            useMockData={useMockData}
            displayToast={displayToast}
          />
        )}
        {currentPage === "batchEvaluations" && (
          <BatchEvaluationsContent
            navigateTo={navigateTo}
            selectedCourseTitle={selectedCourseTitle}
            selectedCourseId={selectedCourseId}
            selectedBatchId={batchId}
            useMockData={useMockData}
            displayToast={displayToast}
          />
        )}
        {currentPage === "createBatchEvaluation" && (
          <CreateUpdateBatchEvaluationForm
            navigateTo={navigateTo}
            selectedBatchId={selectedBatchId}
            useMockData={useMockData}
            displayToast={displayToast}
          />
        )}
        {currentPage === "assignEvaluationToBatch" && (
          <AssignEvaluationToBatchForm
            navigateTo={navigateTo}
            selectedBatchId={selectedBatchId}
            selectedCourseTitle={selectedCourseTitle}
            selectedEvaluationId={evaluationId}
            useMockData={useMockData}
            displayToast={displayToast}
          />
        )}
        {currentPage === "batchAssignments" && (
          <BatchAssignmentsContent
            navigateTo={navigateTo}
            selectedBatchId={selectedBatchId}
            selectedCourseTitle={selectedCourseTitle}
            useMockData={useMockData}
            displayToast={displayToast}
          />
        )}
        {currentPage === "viewAssignments" && (
          <AssignmentsContent
            navigateTo={navigateTo}
            evaluationId={evaluationId}
            useMockData={useMockData}
            displayToast={displayToast}
          />
        )}
        {currentPage === "evaluationAssignments" && (
          <EvaluationAssignmentsContent
            navigateTo={navigateTo}
            selectedBatchId={selectedBatchId}
            selectedCourseTitle={selectedCourseTitle}
            selectedEvaluationId={evaluationId}
            useMockData={useMockData}
            displayToast={displayToast}
          />
        )}
        {currentPage === "accountSettings" && (
          <AccountSettingsContent
            navigateTo={navigateTo}
            selectedBatchId={selectedBatchId}
            selectedCourseTitle={selectedCourseTitle}
            selectedEvaluationId={evaluationId}
            useMockData={useMockData}
            displayToast={displayToast}
          />
        )}
        {currentPage === "resources" && (
          <ResourcesContent
            navigateTo={navigateTo}
            selectedBatchId={selectedBatchId}
            selectedCourseTitle={selectedCourseTitle}
            selectedEvaluationId={evaluationId}
            useMockData={useMockData}
            displayToast={displayToast}
          />
        )}
        {currentPage === "studentHub" && (
          <StudentsApp
            navigateTo={navigateTo}
            studentId={studentId}
            useMockData={useMockData}
            displayToast={displayToast}
          />
        )}
        {currentPage === "teacherDashboard" && (
          <AnalyticsDashboard displayToast={displayToast} />
        )}
        {currentPage === "concepts" && (
          <ConceptsContent
            navigateTo={navigateTo}
            displayToast={displayToast} />
        )}
        {currentPage === "conceptDetails" && (
          <ConceptDetailsContent
            conceptCode={conceptCode}
            navigateTo={navigateTo}
            displayToast={displayToast} />
        )}
        {currentPage === "startQuiz" && (
          <MasterQuizApp
            selectedEvaluation={evaluationId}
            quizMode={quizMode}
            navigateTo={navigateTo}
            displayToast={displayToast} />
        )}
        {currentPage === "joinQuiz" && (
          <StudentQuizApp
            studentId={studentId}
            navigateTo={navigateTo}
            displayToast={displayToast} />
        )}
        {isLoading && <GlobalLoader />}
      </div>
    </>
  );
};
export default Layout;
